import React from "react";
import FlipMove from "react-flip-move";

export default ({ children, block }) => {
  const { enterAnimation, leaveAnimation, delay, space, direction } = block;
  const vectorSpace = direction === "horizontal" ? [1, 0] : [0, 1];
  const margin = i =>
    i !== React.Children.count(children) - 1
      ? { marginRight: space * vectorSpace[0], marginBottom: space * vectorSpace[1] }
      : {};
  return (
    <FlipMove
      appearAnimation={enterAnimation}
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
      delay={delay}
      style={{ display: "flex", flexDirection: direction === "horizontal" ? "row" : "column" }}>
      {React.Children.map(children, (c, i) => {
        return (
          <div key={c.props.dataKey} style={margin(i)}>
            {c}
          </div>
        );
      })}
    </FlipMove>
  );
};



// WEBPACK FOOTER //
// ./src/canvas/enhancers/collectionable.js